'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeAddMatterIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeAddMatterIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_222_36991)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.97131 1.25715C7.77427 0.453188 8.86363 0.00100258 9.99989 2.27855e-06H27.1427C27.3305 -0.000332999 27.5164 0.0363357 27.69 0.107912C27.8635 0.179488 28.0213 0.284569 28.1542 0.417145L39.5827 11.8457C39.7153 11.9786 39.8204 12.1364 39.892 12.3099C39.9636 12.4835 40.0002 12.6694 39.9999 12.8571V35.7143C39.9999 36.2771 39.889 36.8344 39.6737 37.3544C39.4583 37.8743 39.1426 38.3468 38.7446 38.7447C38.3467 39.1427 37.8742 39.4584 37.3542 39.6738C36.8343 39.8892 36.277 40 35.7142 40H14.5856C14.8513 39.3371 14.9999 38.6143 14.9999 37.8571V36.4286H16.4285C17.944 36.4286 19.3974 35.8265 20.4691 34.7549C21.5407 33.6833 22.1427 32.2298 22.1427 30.7143C22.1427 29.1988 21.5407 27.7453 20.4691 26.6737C19.3974 25.602 17.944 25 16.4285 25H14.9999V23.5714C14.9998 22.4949 14.6955 21.4403 14.1223 20.5292C13.549 19.618 12.73 18.8873 11.7596 18.4212C10.7893 17.9551 9.70696 17.7726 8.6374 17.8947C7.56783 18.0169 6.55452 18.4386 5.71417 19.1114V4.28572C5.71417 3.14857 6.1656 2.05715 6.97131 1.25715Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.28571 21.4277C9.56712 21.4277 9.84577 21.4832 10.1058 21.5909C10.3657 21.6985 10.602 21.8564 10.8009 22.0554C10.9999 22.2543 11.1578 22.4906 11.2655 22.7506C11.3731 23.0105 11.4286 23.2892 11.4286 23.5706V28.5706H16.4286C16.9969 28.5706 17.5419 28.7964 17.9438 29.1982C18.3457 29.6001 18.5714 30.1451 18.5714 30.7135C18.5714 31.2818 18.3457 31.8268 17.9438 32.2287C17.5419 32.6305 16.9969 32.8563 16.4286 32.8563H11.4286V37.8563C11.4286 38.4246 11.2028 38.9697 10.8009 39.3715C10.3991 39.7734 9.85404 39.9992 9.28571 39.9992C8.71739 39.9992 8.17235 39.7734 7.77048 39.3715C7.36862 38.9697 7.14286 38.4246 7.14286 37.8563V32.8563H2.14286C1.57454 32.8563 1.02949 32.6305 0.627628 32.2287C0.225765 31.8268 0 31.2818 0 30.7135C0 30.1451 0.225765 29.6001 0.627628 29.1982C1.02949 28.7964 1.57454 28.5706 2.14286 28.5706H7.14286V23.5706C7.14286 23.0023 7.36862 22.4572 7.77048 22.0554C8.17235 21.6535 8.71739 21.4277 9.28571 21.4277Z"
            fill="#3D517B"
          />
        </g>
        <defs>
          <clipPath id="clip0_222_36991">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeAddMatterIcon.propTypes = {
  sx: PropTypes.object
}
